export default __webpack_public_path__ + "freebies.ef38622292761c5e6c2462177b6f6145.png";